module.exports = __webpack_public_path__ + "d83c6dbf9fcf5a5ec5809759bee7f159.svg";